/* eslint-disable */
import React from 'react';
import { PhotoCapture } from '../_shared/PhotoCapture';

function Page() {
  return (
    <PhotoCapture
      page="hairstyle-women-photo"
      progress={92}
      ns="hairstyleWomenPhoto"
      exampleName="upload-front-example.jpg"
      field="hairstyleWomenFront"
      setter="setHairstyleWomenFront"
      urlSetter="setHairstyleWomenFrontUrl"
      outline="front"
    />
  );
}

export default Page;
